<template>
  <sonko-layout>
    <vue-headful title="eWak" />
    <v-layout wrap>
      <v-toolbar flat dense class="toolbarColor mx-3">
        <v-toolbar-title class="title" v-if="editStatus == 'editing'">Edit Ticket</v-toolbar-title>
        <v-toolbar-title class="title" v-else>Post A New Ticket</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <editor
        @data="save"
        @edata="update"
        :loading="loading"
        :initial="ticket"
        :editStatus="editStatus"
        :ticketError="ticketError"
      ></editor>
    </v-layout>
  </sonko-layout>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  name: "CreateTicketsPage",
  components: {
    Editor
  },
  data() {
    return {
      ticket: {},
      editStatus: null,
      loading: false,
      ticketError: ''
    };
  },
  methods: {
    save(data) {
      this.loading = true;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/ticket", data })
        .then(res => {
          self.loading = false;
          self.ticket = {};
          if(res.state==true) {
            this.$router.push("/tickets");
          } else {
            self.ticketError = res.msg;
          }
        })
        .finally(() => {});
    },
    update(details) {
      const data = details.formData;
      const id = details.id;
      this.loading = true;
      const self = this;
      const res = this.$store
        .dispatch("put", { url: "/ticket/update/" + id, data })
        .then(res => {
          self.loading = false;
          self.ticket = {};
          if(res.state==true){
            this.$router.push('/ticket/details/'+ res.ticket._id);
          }
          else{
            location.reload();
          }   
        })
        .finally(() => {});
    }
  },
  created() {
    const id = this.$route.query.id;
    if (id !== undefined) {
      this.$store.dispatch("get", "/ticket/" + id).then(res => {
        this.ticket = res.ticket;
        this.editStatus = "editing";
      });
    }
  }
};
</script>